import React, {FC, ReactNode} from 'react';

const style = {
	container: `flex flex-col gap-y-4   w-full h-full   text-whirlwindLightest`,
};

type PrimaryContentBoxProps = {
	children?: ReactNode;
	tailwindcss?: string;
};

export const PrimaryContentBox: FC<PrimaryContentBoxProps> = ({
	children,
	tailwindcss,
}) => {
	return (
		<div className={`${style.container} ${tailwindcss ? tailwindcss : ''}`}>
			{children}
		</div>
	);
};
